import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MailLinkDto } from '../interfaces';
import { ICourrierIDelibeLinks } from 'src/app/shared/models/iDelibe/delibe-links';
import { DelibeLinksDTO } from '../interfaces/links/delibe-links.interface';
import { CourrierLinksParams, GlobalLinkTypesParams } from 'src/app/shared/models/iCourrier/links';
import { GlobalLinksTypeDTO } from '../interfaces/global/global-links-types.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MailsLinksService {
  private url: string;

  constructor(private http: HttpClient) {
    const config = environment;
    this.url = config.apiICourrierBaseUrl;
  }

  /*
    Retrieves all types of mail link
  */
  getGlobalTypes(options?: GlobalLinkTypesParams): Observable<GlobalLinksTypeDTO[]> {
    return this.http.get<GlobalLinksTypeDTO[]>(`${this.url}/Global/Links/Types`, { params: options ? { ...options } : {} });
  }

  //#region Mails Links
  public fetchMailLinks(mailId: number): Observable<MailLinkDto[]> {
    return this.http.get<MailLinkDto[]>(`${this.url}/Mails/${mailId}/Links`);
  }

  public postLinks(data: CourrierLinksParams): Observable<MailLinkDto> {
    return this.http.post<MailLinkDto>(`${this.url}/Mails/Links`, data);
  }

  deleteLinks(data: CourrierLinksParams): Observable<void> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: data,
    };
    return this.http.delete<void>(`${this.url}/Mails/Links`, options);
  }
  //#endregion

  //#region Delibe lien
  getIDelibeLinks(courrierId: number): Observable<DelibeLinksDTO> {
    return this.http.get<DelibeLinksDTO>(`${this.url}/Mails/${courrierId}/DelibeLiens`);
  }

  postLinkCourrierIdDelibeId(courrierId: number, data: ICourrierIDelibeLinks): Observable<DelibeLinksDTO> {
    return this.http.post<DelibeLinksDTO>(`${this.url}/Mails/${courrierId}/DelibeLiens`, data);
  }

  deleteIDelibeLinks(courrierId: number, linkId: number): Observable<void> {
    return this.http.delete<void>(`${this.url}/Mails/${courrierId}/DelibeLiens/${linkId}`);
  }

  //#endregion
}
